// O Bootstrap 4.3.1+ passa o HTML de popovers e tooltips (content, title e template) por um
// sanitizador: tag ou atributo fora da lista some, e o href que não seja http(s), mailto, ftp, tel
// ou caminho também. Aqui entra só o que o painel usa de verdade; o resto continua cortado. Os
// popovers e tooltips com HTML são inicializados depois deste arquivo (ready), então a lista já
// vale para eles. Outros usos: `style` num popover não passa, use classe do Bootstrap.
(function ($) {
  var whiteList = $.fn.popover.Constructor.Default.whiteList;

  // admin/accounts: os botões de ação da conta moram dentro do popover (admin/accounts/buttons/
  // _account_action_popover). O accounts.js lê data-form e data-url do botão e o data-toggle/
  // data-target abre o modal da ação.
  whiteList.a = whiteList.a.concat(["data-form", "data-url", "data-toggle", "data-target"]);
})(jQuery);
